import { Injectable, Inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { SeoLinkService } from './seo-link.service';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(private meta: Meta,
    private title: Title,
    private link: SeoLinkService,
    @Inject(DOCUMENT) private document) {
  }

  execute(title, keywords, description) {
    this.title.setTitle(title);
    this.meta.updateTag({ name: 'keywords', content: keywords });
    this.meta.updateTag({ name: 'description', content: description });
  }

  robots(actions: string) {
    this.meta.updateTag({ name: 'robots', content: actions });
    this.meta.updateTag({ name: 'googlebot', content: actions });
  }

  canonical(href: string) {
    const head = this.document.head;
    const elements = head.getElementsByTagName('link');
    const indexes = [];
    for (let i = 0; i < elements.length; i++) {
      if (elements.item(i).getAttribute('rel') === 'canonical') {
        indexes.push(i);
      }
    }
    indexes.forEach(i => head.removeChild(elements.item(i)));
    this.link.addTag({ rel: 'canonical', href });
  }

}
